export const UNSAVED_CHANGES_MESSAGE = 'You have unsaved changes. Leave this page and discard them?';
